<template>
  <div>
    <div class="forgot-pass-box text-center">
      <div class="forgot-pwd-title" v-translate:FORGOT_PASSWORD_TITLE="lang">
        Forgot Password
      </div>
      <div class="forgot-pwd-wrapper">
        <p class="forgot-pwd-text mb-7" v-translate:label_forgot_password_sub_title="lang">
          Enter your username to reset your password.
        </p>
        <div class="form-group">
          <input
            type="text"
            v-validate="'required'"
            name="username"
            @keyup="validateUsername(username)"
            :class="{
              input: true,
              'is-danger': errors.has('username'),
              'is-success': !errors.has('username')
            }"
            class="form-control"
            v-model="username"
            required
          />
          <label v-translate:label_username="lang">Username</label>
        </div>

        <div class="text-center forgot-pwd-btn">
          <button type="submit" class="btn btn-submit primary-bg" v-on:click.prevent="verifyUsername" :disabled="!isValid">
            {{ submitBtnTitle }}
          </button>
        </div>
      </div>
    </div>
    <Modal :show="showVerificationSentModal" :title="modal.title" :helpText="modal.helpText" :okButton="modal.okBtnTitle" @modalCallback="modalCallback"></Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget, ParticipantPortal, Validations } from "@/components/services/participant-service";
import nprogress from "nprogress";
import Modal from "@/components/participant-portal/common/modal";

export default {
  name: "auth-verify-username",
  props: ["buttonTitle", "navTitle", "isOnBackClick", "lang", "eventType"],
  components: { Modal },
  data() {
    return {
      username: "",
      widget: new Widget(),
      validate: new Validations(),
      portal: new ParticipantPortal(),
      isPhoneDelivery: false,
      forgotUsername: {
        language: null,
        studyId: "0",
        deviceType: "web"
      },
      showVerificationSentModal: false,
      isEmailSent: false,
      modal: {
        title: "",
        helpText: "",
        okBtnTitle: "",
        cancelBtnTitle: ""
      },
      usernameValidation: {
        isValidUnique: false,
        isValidSpecial: false,
        isValidLength: false
      },
      usernameValidator: {
        minLength: 8,
        minLetter: 0,
        minNumber: 0,
        minSpecial: 0,
        regSpecial: new RegExp(/^[\p{L}\p{N}][\p{L}\p{N}.@_-]*[\p{L}\p{N}]$/, "gu"),
        regLetter: new RegExp(/\p{L}/, "gu"),
        regNumber: new RegExp(/\p{N}/, "gu")
      },
      cognitoEmail: null
    };
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    submitBtnTitle() {
      return this.buttonTitle ? this.buttonTitle : this.widget.translate("label_submit", "Submit");
    },
    isValid() {
      const filterKeys = ["isValidUnique", "isValidSpecial", "isValidLength"];
      const validOptions = Object.entries(this.usernameValidation).filter(e => filterKeys.includes(e[0]) && e[1] == true);
      return validOptions.length >= 3;
    }
  },
  methods: {
    validateUsername(username) {
      Object.assign(this.usernameValidation, this.validate.validateUsername(username.toLowerCase(), this.usernameValidator));
      this.usernameValidation.isValidUnique = true;
    },
    setModalDetails() {
      this.modal.title = this.widget.translate("pweb_title_verification_code_sent", "Verification Code Sent");
      this.modal.helpText = this.isPhoneDelivery ? this.widget.translate("mobile_reset_password", "An SMS text with a code to reset your password has been sent to you.") : this.widget.translate("label_verification_code_sent", "An email with a code to reset your password has been sent to you.");
      this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
    },
    verifyUsername() {
      nprogress.start();
      this.setModalDetails();
      const that = this;
      this.portal
        .cognitoCheckUsername(this.username.toLowerCase())
        .then(res => {
          if (res.errorMessage && res.errorMessage == "USERNAME_EXISTS") {
            that.portal
              .cognitoForgotUsername(that.username.toLowerCase())
              .then(resp => {
                that.cognitoEmail = resp.CodeDeliveryDetails.Destination;
                that.isPhoneDelivery = resp.CodeDeliveryDetails.DeliveryMedium === "SMS";
                that.setModalDetails();
                that.showVerificationSentModal = !that.showVerificationSentModal;
                nprogress.done();
              })
              .catch(errorMessage => {
                nprogress.done();
                if (errorMessage) {
                  this.$toastr.error(errorMessage);
                }
              });
          } else {
            nprogress.done();
            const message = this.widget.translate("label_username_not_found", "Username not found.");
            this.$toastr.error(message);
          }
        })
        .catch(() => {
          nprogress.done();
          const message = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
          this.$toastr.error(message);
        });
    },
    modalCallback() {
      const username = this.username ? this.username.toLowerCase() : this.username;
      if (this.eventType == "username") {
        this.$emit("updateActiveScreen", {
          key: "verifyOtp",
          flagKey: "createUsername",
          flagChild: "username",
          flagValue: username
        });
      } else if (this.eventType == "password") {
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "username",
          flagValue: username
        });
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "cognitoEmail",
          flagValue: username
        });
      } else {
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "username",
          flagValue: username
        });
      }
    },
    forgotPassword(postData) {
      this.setModalDetails();
      this.$api.sendOtpToVerifyEmail(postData).then(
        response => {
          if (response.data.errorCode == null) {
            this.showVerificationSentModal = !this.showVerificationSentModal;
          } else {
            const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
            this.$toastr.error(title);
          }
        },
        () => {
          const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
          this.$toastr.error(title);
        }
      );
    }
  }
};
</script>
